<template>

    <div class="addentranceVehicle">
   <big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>

        <div class="nav clearfix">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">离场</van-col>
            </row>
        </div>
        <van-form class="form">
            
            <van-field
                v-model="submititem.vehicleCode"
                clearable
                icon="question-o"
                label="车辆编号"
                :border="true"
                :required="true"
                maxlength="30"
                placeholder="输入车辆编号"
                bind:click-icon="onClickIcon"
                :rules="[ { required: true, message: '必填' } ]"
                @keyup="queryvehicleCode"
                @clear="clearvehicleCode" />
            <Popup
                v-model="showPicker"
                position="bottom">
                <van-picker
                    show-toolbar
                    :columns="vehicleCodeColumn"
                    @cancel="showPicker = false"
                    @confirm="onConfirm" />
            </Popup>
            <div style='position: relative;top:0;left:0;'>
                <van-field
                    v-model="submititem.barCode"
                    clearable
                    icon="question-o"
                    label="条码编号"
                    label-class=""
                    :border="true"
                    maxlength="30"
                    placeholder="输入条码编号"
                    :required="true"
                    :rules="[ { required: true, message: '必填' } ]"
                    bind:click-icon="onClickIcon"
                    @clear="clearbarCode"
                    @keyup="querybarCode" />
                    <van-col span="2" style="float:right; margin:7px 0px 0 15px !important;">
                        <van-icon style='position:absolute;top:3px;right:20px;' name="scan" size="30" round title="扫一扫"
                            @click="carScan('离场')" />
                    </van-col>
            </div>
           
            <Popup
                v-model="showbarCode"
                position="bottom">
                <van-picker
                    show-toolbar
                    :columns="barCodeColumn"
                    @cancel="showbarCode = false"
                    @confirm="barcodeConfirm" />
            </Popup>
            <van-field
                v-model="submititems.category"
                icon="question-o"
                label="车辆类别"
                :border="true"
                :required="true"
                :disabled="true"
                maxlength="30"
                placeholder="输入车辆类别"
                bind:click-icon="onClickIcon" />
            <van-field
                v-model="submititems.model"
                icon="question-o"
                label="型号"
                :border="true"
                :required="true"
                :disabled="true"
                maxlength="30"
                placeholder="输入车辆型号"
                bind:click-icon="onClickIcon" />
            <van-field
                v-model="submititems.chassisNumber"
                icon="question-o"
                label="底盘号"
                :border="true"
                :required="true"
                :disabled="true"
                maxlength="30"
                placeholder="输入机号"
                bind:click-icon="onClickIcon" />

            <van-field
                v-model="submititems.brand"
                icon="question-o"
                label="品牌"
                :border="true"
                :required="true"
                :disabled="true"
                maxlength="30"
                placeholder="输入品牌"
                bind:click-icon="onClickIcon" />
            <van-field
                v-model="submititems.owner"
                icon="question-o"
                label="权责人"
                :border="true"
                :required="true"
                :disabled="true"
                maxlength="30"
                placeholder="输入权责人"
                bind:click-icon="onClickIcon" />
            <van-field
                v-model="driversdata"
                :clearable="true"
                readonly
                icon="question-o"
                autosize
                type="textarea"
                label="驾驶员"
                :border="true"
                placeholder="输入驾驶员姓名电话"
                bind:click-icon="onClickIcon"
                @clear="cleardriver"
                @click="queryDrivers" />
            <Popup
                v-model="date"
                position="bottom"
                :style="{ height: '20%' }">
                <DatetimePicker
                    v-model="visitCurrentDate"
                    type="datetime"
                    :min-date="minDate"
                    @confirm="visitSelectDate"
                    @cancel="showDate" />
            </Popup>
            <van-field
                v-model="submititems.entryTime"
                icon="question-o"
                is-link
                label="离场时间"
                :border="true"
                :required="true"
                maxlength="30"
                disabled
                arrow-direction="down"
                placeholder="输入离场时间"
                bind:click-icon="onClickIcon"
                :rules="[ { required: true, message: '必填' } ]"
                />
            <Popup
                v-model="showDrivers"
                :style="{ height: '30%' }"
                position="bottom">
                <van-checkbox-group v-model="checkedDrivers">
                    <van-cell-group>
                        <van-cell
                            v-for="(item,index) in driversColumn"
                            :key="item.id"
                            clickable
                            :title="`${item.name+'-'+item.contactNo}`"
                            @click="toggle(item,index)">
                            <van-checkbox slot="right-icon" ref="checkboxes" :name="item.id" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </Popup>
           <!-- <div class="container">
            <div class="Uploader">
              <div class="image">上传图片
              </div>
                <div class="imgAdd">
                    <span class="itemImg" v-for="(item,index) in fileList " :key="index">
                        <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                        <img src="./image/del.png" alt="" @click="delImg(index)" class="delte">
                    </span>
                    <div class="fileupload-box" v-show="this.fileList.length<=5">
                        <div class="c" @click='clicktotakephotose'>
                            <img src="./image/1.png" id="image">
                        </div>

                    </div>
                </div>
            </div>
            </div> -->
            <div style="padding:0 10px;">
                <row :gutter="20">
                    <!-- <van-col span="24">
                        <van-button round block type="info" class="nextSpan" @click="submit(false)">提交</van-button>
                    </van-col> -->
                    <van-col span="24">
                        <van-button round block type="info" class="nextSpan"
                            @click="submits()">提交</van-button>
                    </van-col>
                    <!-- <van-col span="12">
                        <van-button round block type="info" class="nextSpan"
                            @click="submitandhandle">提交并处理</van-button>
                    </van-col> -->
                </row>
            </div>
            <div style="height:1.2rem;" />
        </van-form>
        <bottom />
    </div>
</template>

<script>
import { Icon, Notify, Form, Tab, Tabs, DatetimePicker, Popup, Cell, CellGroup, Toast, List, Button, Field, Switch, Radio, Col, Row, RadioGroup, Picker, Checkbox, CheckboxGroup } from 'vant'
import bottom from '@/components/bottom'
import { getcategory, getbrand, uploadAnnex, getvehicleCodeList, getvehicleInfoItem, getDriverList, getbarCodeList } from '@/api/basics'
import { entranceOrExit } from '@/api/maintain'
import uuidv1 from 'uuid/v1'
import Vue from 'vue'
import { Uploader } from 'vant'
import BigImg from './components/bigImg.vue'

Vue.use(Uploader)
export default {
    name: 'AddentranceVehicle',
    components: {
        bottom,BigImg,
        Icon, [Button.name]: Button, [Col.name]: Col, Row, [CellGroup.name]: CellGroup, [Field.name]: Field, Notify, DatetimePicker, Popup, [Cell.name]: Cell, [Picker.name]: Picker, [Checkbox.name]: Checkbox, [CheckboxGroup.name]: CheckboxGroup, [Form.name]: Form
    },
    data() {
        return {
            showImg:false,
            imgSrc: '',
            submititem: {
               enumVehicleStatus:2,
               Scan:0
            },
            submititems:{
                Id: '',
                vehicleId: '',
                vehicleCode: '',
                barCode: '',
                enumVehicleStatus: 1,
                chassisNumber: '',
                category: '',
                brand: '',
                modelId: '',
                model: '',
                customer: '',
                customerId: '',
                phone: '',
                owner: '',
                entryTime: '',
                drivers: [],
                driver: '',
                driverPhone: '',
                outStockType: '',
                faultDescription: '',
                entranceUrl: ''
            },
            fileList: [],
            vals: 'http://test.parts.ytkj.org/api-atta/doc/a1c601ba-d85d-4b5b-8718-41e10b73a609.jpg',
            driversdata: '',
            date: false,
            minDate: new Date(2020, 0, 1),
            maxDate: '',
            visitCurrentDate: new Date(),
            vehicleCodeList: [],
            barCodeList: [],
            vehicleCodeColumn: [],
            barCodeColumn: [],
            showPicker: false,
            showbarCode: false,
            showDrivers: false,
            driversColumn: [],
            checkedDrivers: [],
            images: []
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // 通过 `vm` 访问组件实例
            console.log('创建')
            if(vm.$route.query.type=='创建'){
                vm.submititem={
                    Id: '',
                    vehicleId: '',
                    vehicleCode: '',
                    barCode: '',
                    enumVehicleStatus: 1,
                    chassisNumber: '',
                    category: '',
                    brand: '',
                    modelId: '',
                    model: '',
                    customer: '',
                    customerId: '',
                    phone: '',
                    owner: '',
                    entryTime: '',
                    driver: '',
                    driverPhone: '',
                    outStockType: '',
                    faultDescription: '',
                    entranceUrl: ''
                }
                vm.driversdata=''
                vm.fileList=[]
                vm.visitSelectDate(new Date())
            }
        })
    },
    created() {
        var day1 = new Date()
        this.minDate = new Date(day1.getFullYear() - 1, 0, 1)
        // this.submititem.id = uuidv1()
            
        
    },
    mounted() {
        window['scanit'] = data => {
            this.scanit(data)
        }
        this.visitSelectDate(new Date())
        
        
        // this.loadDrivers()
    },
    activated(){
      this.showImg = false;
    },
    methods: {
        clickImg(e) {
        this.showImg = true;
        // 获取当前图片地址
        this.imgSrc = e.currentTarget.src;

        },
        viewImg(){
        this.showImg = false;
        },
        // 上传图片处理
        afterRead(file, e) {
            console.log(file, this.fileList)
            this.$store.dispatch('user/photo', this.fileList)
        },
        // 返回
        getBack() {
            this.$router.push({
                path: '/',
            })
        },
        // 点击删除
    delImg(index) {
    this.submititem.entranceUrl = ''
      if (isNaN(index) || index >= this.fileList.length) {
        return false;
      }
      this.fileList.splice(index, 1);
      if(this.fileList.length>0){
          this.fileList.forEach(item=>{
            this.submititem.entranceUrl = this.submititem.entranceUrl.concat(item.url + ';')
          })
      }
      console.log(this.submititem.entranceUrl)
    },
        // 提交
        submits() {
        this.submititem.drivers = this.driversdata ? this.driversdata.split(',') : []
            if (this.submititem.vehicleId == '') {
                Toast('车辆编号不能为空')
                return false
            }
            entranceOrExit(this.submititem).then((res) => {
                if (res.isSuccess) {
                    Notify({ type: 'success', message: '提交成功' })
                    // return
                    if (res.code==200) {
                        this.$router.push({
                            path: '/',
                        })
                    } else {
                        this.$router.push({
                            path: '/entrancevehicle'
                        })
                    }
                } else {
                    Toast(res.message)
                    return false
                }
            })
        },
        // 提交
        // submit(value) {
        //     this.submititem.drivers = this.driversdata ? this.driversdata.split(',') : []
        //     if (this.submititem.vehicleId == '') {
        //         Toast('车辆编号不能为空')
        //         return false
        //     }
        //     entranceOrExit(this.submititem).then((res) => {
        //         if (res.isSuccess) {
        //             Notify({ type: 'success', message: '提交成功' })
        //             // return
        //             if (value) {
        //                 if (this.$_has('maintain:workorder:view')) {
        //                     this.$router.push({
        //                         path: '/dispatchList',
        //                         query: {
        //                             type: '入场处理',
        //                             id: this.submititem.id
        //                         }
        //                     })
        //                 } else {
        //                     this.$router.push({
        //                         path: '/404'
        //                     })
        //                 }
        //             } else {
        //                 this.$router.push({
        //                     path: '/entrancevehicle'
        //                 })
        //             }
        //         } else {
        //             Toast(res.message)
        //             return false
        //         }
        //     })
        // },
        // 提交并处理
        // submitandhandle() {
        // if (this.submititem.vehicleId == '') {
        //     Toast('车辆编号不能为空')
        //     return false
        // }
        // if (!this.submititem.owner) {
        //     Toast.fail('请先维护车辆档案的权责人')
        //     return
        // }
        // if (!this.submititem.drivers.length == 0) {
        //     Toast.fail('请先维护车辆档案的驾驶员')
        //     return
        // }
        // this.submit(true)
        // },

        showDate() {
            this.date = !this.date
        },
        visitSelectDate(date) {
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            this.submititems.entryTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + hours + ':' + minutes
            this.date = false
        },
        querybarCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.barCodeColumn = []
            var refData = []

            getbarCodeList(this.submititem.barCode).then((res) => {
                if (res.code == 200) {
                    this.barCodeList = res.data
                    console.log(this.barCodeList)
                    if (this.barCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.barCodeList.length; i++) {
                            refData[i] = this.barCodeList[i].barCode
                        }
                    }
                    this.barCodeColumn = refData
                    this.showbarCode = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        scanit(val){
            this.submititem.barCode=val
            this.querybarCode()
            console.log(val)
        },
        // 根据车辆变化查询
        queryvehicleCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.vehicleCodeColumn = []
            var refData = []

            getvehicleCodeList(this.submititem.vehicleCode).then((res) => {
                if (res.code == 200) {
                    this.vehicleCodeList = res.data
                    if (this.vehicleCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.vehicleCodeList.length; i++) {
                            refData[i] = this.vehicleCodeList[i].code
                        }
                    }
                    this.vehicleCodeColumn = refData
                    this.showPicker = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        onChange(picker, values) {
            ``
        },
        barcodeConfirm(value, index) {
            var item = this.barCodeList[index]
            getvehicleInfoItem(item.id).then((res) => {
                if (res.code == 200) {
                    this.checkedDrivers = []

                    this.submititem.vehicleCode = res.data.code
                    this.submititem.vehicleId = res.data.id
                    this.submititem.outStockType = item.outStockType
                    this.submititem.faultDescription = item.faultDescription
                    this.submititem.barCode = res.data.barCode
                    this.submititems.chassisNumber = res.data.chassisNum
                    this.submititems.category = res.data.machineCategoryName
                    //  this.submititem.category = res.data.machineCategory
                    this.submititems.brand = res.data.machineBrandName
                    this.submititem.modelId = res.data.machineModelId
                    this.submititems.model = res.data.machineModel
                    this.submititems.customer = res.data.customerName
                    this.submititem.customerId = res.data.customerId
                    this.submititem.phone = item.driverPhone
                    this.submititems.owner = res.data.ownerNames
                }
            })
            this.showbarCode = false
        },
        // 选择车辆编号
        onConfirm(value, index) {
            var item = this.vehicleCodeList[index]
            getvehicleInfoItem(item.id).then((res) => {
                if (res.code == 200) {
                    this.checkedDrivers = []

                    this.submititem.vehicleCode = res.data.code
                    this.submititem.vehicleId = res.data.id
                    this.submititem.outStockType = item.outStockType
                    this.submititem.faultDescription = item.faultDescription
                    this.submititem.barCode = res.data.barCode
                    this.submititems.chassisNumber = res.data.chassisNum
                    this.submititems.category = res.data.machineCategoryName
                    this.submititems.brand = res.data.machineBrandName
                    this.submititem.modelId = res.data.machineModelId
                    this.submititems.model = res.data.machineModel
                    this.submititems.customer = res.data.customerName
                    this.submititem.customerId = res.data.customerId
                    this.submititem.phone = item.driverPhone
                    this.submititems.owner = res.data.ownerNames
                    // var driverParam = {}
                    // driverParam.customerId = res.data.customerId
                    // driverParam.PageIndex = 0
                    // driverParam.PageSize = 1000
                    // getDriverList(driverParam).then((resdriver) => {
                    //     if (resdriver.code == 200) {
                    //         this.driversColumn = resdriver.data.pagerData
                    //         var i = 0
                    //         for (i; i < this.driversColumn.length; i++) {
                    //             this.driversColumn[i].checked = false
                    //         }

                    //         if (res.data.vehicleDrivers.length > 0) {
                    //             var j = 0
                    //             var jj = 0
                    //             for (j; j < res.data.vehicleDrivers.length; j++) {
                    //                 var h = 0
                    //                 for (h; h < this.driversColumn.length; h++) {
                    //                     if (this.driversColumn[h].name == res.data.vehicleDrivers[j].driverName && this.driversColumn[h].contactNo == res.data.vehicleDrivers[j].driverPhone) {
                    //                         this.driversColumn[h].checked = true
                    //                         this.checkedDrivers[jj] = this.driversColumn[h].id
                    //                         jj++
                    //                     }
                    //                 }
                    //             }
                    //         }
                    //         this.onDriversConfirm()
                    //     } else {
                    //         this.onDriversConfirm()
                    //     }
                    // })
                }
            })
            this.showPicker = false
        },
        async queryDrivers() {
            this.showDrivers = true
            this.driversColumn = []
            if (!this.submititem.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.submititem.customerId
            }
            // this.form.driver = null
            await getDriverList(param).then(res => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach(item => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                    if (this.driversColumn) {
                        this.driversColumn.forEach(element => {
                            this.driversdata.split(',').forEach(items => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    } else {
                        this.checkedDrivers = []
                    }
                }
            })
        },
        cleardriver() {
            console.log('cleardriver')
            this.driversdata = []
        },
        clearbarCode() {
            console.log('clearvehicleCode')
            this.submititem.barCode = ''
        },
        clearvehicleCode() {
            console.log('clearvehicleCode')
            this.submititem.vehicleCode = ''
        },
        faultDescriptions() {
            this.submititem.faultDescription = ''
        },
        // 选择drivers
        loadDrivers(data) {
            this.driversColumn = []
            getDriverList(data).then((res) => {
                if (res.code == 200) {
                    this.driversColumn = res.data.pagerData
                    var i = 0
                    for (i; i < this.driversColumn.length; i++) {
                        this.driversColumn[i].checked = false
                    }
                }
            })
        },
        toggle(item, index) {
            // this.$refs.checkboxes[index].toggle();
            // Toast(item.checked);
            if (item.checked == true) {
                item.checked = false
                this.$refs.checkboxes[index].toggle(false)
            } else {
                item.checked = true
                this.$refs.checkboxes[index].toggle(true)
            }
            this.onDriversConfirm()
        },
        //扫一扫
        carScan(value) {
            this.type = value
            window.test.ToScan()
        },
        // 选择drivers
        onDriversConfirm() {
            var j = 0
            this.driversdata = ''
            for (j; j < this.driversColumn.length; j++) {
                if (this.driversColumn[j].checked == false) {
                    continue
                }
                this.driversdata += this.driversColumn[j].name + '-' + this.driversColumn[j].contactNo + ','
            }
            if (this.driversdata.length > 0) {
                this.driversdata = this.driversdata.substring(0, this.driversdata.length - 1)
            }
        }
    }
}
</script>

<style lang='scss'>
* {
  box-sizing: border-box;
}
.container {
  width: 100%;
  background-color: #f5f5f5;
}
.main {
  width: 100%;
  padding: 0 1.5rem;
  text-align: left;
  background-color: #fff;
  padding-top: 1.5rem;
}

.btn {
  width: 100%;
  margin-top: 2.5rem;
  padding: 0 1.5rem;
}
.btn .bottom {
  color: #fff;
  background: red;
  height: 4.4rem;
  line-height: 4.4rem;
  border-radius: 0.4rem;
}
.AddentranceVehicle{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
  .button{
      width: 100px;
      height: 50px;
      background-color: #f44;
      color: #ffffff;
      border-radius: 10px;
      margin-top: 80px;
    }
}
.info-span{
    padding:0px 8px;
    color:#000;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>
<style lang='scss' scoped>

.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
    

      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
.form{
    margin: 10px 0;
}
.form .van-cell__title{font-size: 0.4rem !important;}
</style>
